"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Attachment;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _core = require("@linaria/core");
var _toggleButton = _interopRequireDefault(require("@ux/toggle-button"));
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _base = require("@site/pattern-library-utils/base.functions");
var _tracking = _interopRequireDefault(require("@site/pattern-library-utils/tracking"));
var _intents = _interopRequireDefault(require("./intents.config"));
var _density = require("@site/pattern-library-utils/density");
var _text = _interopRequireDefault(require("@ux/text"));
var _tag = _interopRequireDefault(require("@site/pattern-library-core/tag"));
var _splitPanelItem = _interopRequireDefault(require("../common/split-panel-item"));
var _productContent = _interopRequireDefault(require("../common/product-content"));
var _index = _interopRequireDefault(require("@site/pattern-library/elements/other/lazy-video/index.js"));
var _pillSelection = _interopRequireDefault(require("../pill-selection"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _configContext = require("../context/config-context");
var _bundleContext = require("../context/bundle-context");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable complexity, max-statements */

const AttachmentContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "AttachmentContainer",
  class: "pc-aqfhwia",
  vars: {
    "aqfhwia-0": [({
      hasVideo
    }) => hasVideo ? _intents.default.ux.boxLowContrast.backgroundColor : ''],
    "aqfhwia-1": [({
      hasVideo
    }) => hasVideo ? _intents.default.ux.box.borderRadius : ''],
    "aqfhwia-3": [({
      hasVideo
    }) => hasVideo ? _density.density['3'] : _density.density['1']]
  }
});
const AttachmentContent = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "AttachmentContent",
  class: "pc-a16jxiuz"
});
const VideoContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "VideoContainer",
  class: "pc-v1pahr23"
});
const MobileVideoContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "MobileVideoContainer",
  class: "pc-m99lnni"
});
const NewVideo = /*#__PURE__*/(0, _react2.styled)(_index.default)({
  name: "NewVideo",
  class: "pc-n19qyo2k"
});
const PriceContent = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "PriceContent",
  class: "pc-pfuvgl0",
  vars: {
    "pfuvgl0-0": [({
      isHidden
    }) => isHidden ? 0 : 1],
    "pfuvgl0-1": [({
      isHidden
    }) => isHidden ? '140px' : 'auto'],
    "pfuvgl0-3": [({
      isHidden
    }) => isHidden ? '0ms' : '75ms'],
    "pfuvgl0-5": [({
      hasVideo
    }) => hasVideo ? 'flex-start' : 'flex-end'],
    "pfuvgl0-7": [({
      isHidden,
      priceContentHeight
    }) => isHidden ? '0' : `${priceContentHeight}px`],
    "pfuvgl0-8": [({
      isHidden
    }) => isHidden ? '-0.3125rem' : 0]
  }
});
const ContentWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ContentWrapper",
  class: "pc-c1x2byru"
});
const PillSelectionWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "PillSelectionWrapper",
  class: "pc-pn6sye7",
  vars: {
    "pn6sye7-0": [({
      isVisible,
      contentHeight
    }) => isVisible ? `${contentHeight}px` : '0'],
    "pn6sye7-1": [({
      isVisible
    }) => isVisible ? 1 : 0],
    "pn6sye7-2": [({
      isVisible
    }) => isVisible ? 'auto' : 'none'],
    "pn6sye7-3": [({
      isVisible
    }) => isVisible ? 'translateY(0) scaleY(1)' : 'translateY(-0.5rem) scaleY(0.95)'],
    "pn6sye7-5": [({
      isVisible
    }) => isVisible ? '0.125rem' : '0'],
    "pn6sye7-6": [({
      isVisible
    }) => isVisible ? _density.density['3.5'] : 0]
  }
});
const customToggleStyles = "pc-c1hkcyah";
const TrackingProxy = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TrackingProxy",
  class: "pc-t149yegb"
});

// Helper function to get video content
const getVideoContent = (videoProps, checked) => {
  const {
    thumbnailDesktop,
    videoUrlLaptop,
    videoUrlLaptopWebm,
    thumbnailMobile,
    videoUrl,
    videoUrlWebm
  } = videoProps;
  const videoSource = {
    fallback: thumbnailDesktop,
    laptop: videoUrlLaptop,
    laptopWebm: videoUrlLaptopWebm,
    fallbackMobile: thumbnailMobile,
    base: videoUrl,
    baseWebm: videoUrlWebm
  };
  const hasVideo = Boolean(videoUrl || videoUrlLaptop || videoUrlWebm || videoUrlLaptopWebm || thumbnailDesktop || thumbnailMobile);
  const videoElement = /*#__PURE__*/_react.default.createElement(NewVideo, {
    videoSource: videoSource,
    preload: true,
    autoPlay: false,
    loop: false,
    pause: !checked,
    restartOnPause: true
  });
  const videoContainer = hasVideo ? /*#__PURE__*/_react.default.createElement(VideoContainer, null, videoElement) : null;
  const mobileVideoContainer = hasVideo ? /*#__PURE__*/_react.default.createElement(MobileVideoContainer, null, videoElement) : null;
  return {
    hasVideo,
    videoContainer,
    mobileVideoContainer
  };
};

/**
 * @module Attachment
 *
 * @param {Object} props React props
 * @param {string} props.id Attachment content id
 * @param {string} props._name Tracking name
 * @param {string} props.ariaLabel Aria label for the Attachment toggle
 * @param {string} props.title Attachment product title
 * @param {string} props.secondaryTitle Above image title
 * @param {string} props.description Attachment product description
 * @param {Object} props.flyout Optional tooltip/flyout object
 * @param {string} props.tag Promo tag
 * @param {object} props.video Video configuration object
 * @param {string} props.price Price
 * @param {string} props.priceDescription Price description
 * @param {boolean} props.checked State of the Attachment toggle
 * @param {string} props.setChecked Function to set the state of the Attachment toggle*
 * @param {object} props.image Image object
 * @param {object} props.toggleProps Props for the UX Toggle component
 * @param {boolean} props.displayDisable Applies disabled state for the Attachment toggle
 * @param {array} props.options Multiple choice options when available
 * @returns {React.ReactElement} Attachment component
 * @public
 */
function Attachment({
  id,
  _name,
  productTagLabels,
  ariaLabel,
  title,
  secondaryTitle,
  flyout,
  description,
  list,
  tag,
  video = {},
  price,
  priceDescription,
  onChange,
  inputName,
  inputValue,
  checked,
  setChecked,
  image,
  displayDisable,
  options = [],
  selectedOption: initialSelectedOption = 0
}) {
  const {
    configData
  } = (0, _configContext.useConfig)();
  const {
    isComponentIncluded
  } = (0, _bundleContext.useBundleContext)();
  const {
    included
  } = configData?.commonContent;
  const isIncluded = isComponentIncluded(inputName);
  const [selectedOption, setSelectedOption] = (0, _react.useState)(initialSelectedOption);
  (0, _react.useEffect)(() => {
    if (initialSelectedOption !== selectedOption) {
      setSelectedOption(initialSelectedOption);
    }
  }, [initialSelectedOption]);
  const hasMultipleOptions = options && options.length > 1;
  const shouldShowPriceContent = Boolean(price) || Boolean(tag) || options.length > 0;
  const pillsRef = (0, _react.useRef)(null);
  const priceContentRef = (0, _react.useRef)(null);
  const [contentHeight, setContentHeight] = (0, _react.useState)(0);
  const [priceContentHeight, setPriceContentHeight] = (0, _react.useState)(0);
  const [isPillsAnimating, setIsPillsAnimating] = (0, _react.useState)(false);
  const isInitialRender = (0, _react.useRef)(true);
  const [, startTransition] = (0, _react.useTransition)();
  const containerWidth = (0, _base.useWidthObserver)(pillsRef);
  const {
    displayPrice,
    displayPriceDescription
  } = (0, _react.useMemo)(() => {
    if (options.length > 0 && hasMultipleOptions) {
      return {
        displayPrice: options[selectedOption]?.price || options[0]?.price || price,
        displayPriceDescription: options[selectedOption]?.priceDescription || options[0]?.priceDescription || priceDescription
      };
    }
    return {
      displayPrice: price,
      displayPriceDescription: priceDescription
    };
  }, [options, hasMultipleOptions, selectedOption, price, priceDescription]);
  const getOptionValue = (0, _react.useCallback)((option, index) => {
    if (option.value) return option.value;
    if (option._name) return option._name;
    return `option-${index}`;
  }, []);
  (0, _react.useEffect)(() => {
    if (!isInitialRender.current) return;
    if (checked && hasMultipleOptions && options.length > 0) {
      const currentSelectedIndex = options.findIndex(option => getOptionValue(option, 0) === inputValue);
      if (currentSelectedIndex !== -1 && currentSelectedIndex !== selectedOption) {
        setSelectedOption(currentSelectedIndex);
      }
    }
    isInitialRender.current = false;
  }, [checked, hasMultipleOptions, options, inputValue, selectedOption, getOptionValue]);
  (0, _react.useLayoutEffect)(() => {
    if (hasMultipleOptions && pillsRef.current) {
      const height = pillsRef.current.scrollHeight + 5;
      setContentHeight(height);
    }
  }, [hasMultipleOptions, options, containerWidth]);
  (0, _react.useLayoutEffect)(() => {
    if (shouldShowPriceContent && priceContentRef.current) {
      const height = priceContentRef.current.scrollHeight + 5;
      setPriceContentHeight(height);
    }
  }, [shouldShowPriceContent, displayPrice, displayPriceDescription, tag, containerWidth]);
  (0, _react.useEffect)(() => {
    if (hasMultipleOptions && !checked && selectedOption !== 0) {
      startTransition(() => {
        setSelectedOption(0);
      });
    }
  }, [checked, hasMultipleOptions, selectedOption]);
  const {
    hasVideo,
    videoContainer,
    mobileVideoContainer
  } = (0, _react.useMemo)(() => getVideoContent(video, checked), [video, checked]);
  const productContent = (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement(_productContent.default, {
    title,
    description,
    flyout,
    dataCy: 'attachment',
    secondaryTitle,
    image,
    productTagLabels,
    list
  }), [title, description, flyout, secondaryTitle, image, productTagLabels, list]);

  // Use _name if available, otherwise fall back to id as tracking name
  const trackingName = _name || id || 'attachment';
  const trackName = `toggle_${trackingName}`;
  const trackingProps = _tracking.default.create(trackName, true, false);
  const handleToggleChange = (0, _react.useCallback)(() => {
    const newCheckedState = !checked;
    setIsPillsAnimating(true);
    startTransition(() => {
      if (newCheckedState) {
        if (hasMultipleOptions && options.length > 0) {
          const optionToUse = selectedOption || 0;
          const optionValue = getOptionValue(options[optionToUse], optionToUse);
          onChange(newCheckedState, inputName, optionValue);
        } else {
          onChange(newCheckedState, inputName, inputValue);
        }
      } else {
        onChange(newCheckedState, inputName, inputValue);
      }
      setChecked?.(newCheckedState);
    });
    trackingProps?.ref?.current?.click();
  }, [checked, hasMultipleOptions, options, inputName, inputValue, onChange, setChecked, getOptionValue, selectedOption, trackingProps]);
  const handleOptionSelect = (0, _react.useCallback)(index => {
    if (index === selectedOption) return;
    setIsPillsAnimating(true);
    startTransition(() => {
      setSelectedOption(index);
      if (options[index]) {
        const optionValue = getOptionValue(options[index], index);
        onChange(true, inputName, optionValue);
      }
    });
  }, [selectedOption, options, onChange, inputName, getOptionValue]);
  (0, _react.useEffect)(() => {
    if (isPillsAnimating) {
      const timer = setTimeout(() => {
        setIsPillsAnimating(false);
      }, 600);
      return () => clearTimeout(timer);
    }
  }, [isPillsAnimating]);

  // Separate ref and tracking props pattern (like mobile-nav-link.js)
  const attachmentRef = (0, _react.useRef)(null);
  _tracking.default.useTracking(attachmentRef);
  const priceContent = (0, _react.useMemo)(() => {
    const priceBlockContent = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, tag && /*#__PURE__*/_react.default.createElement(_tag.default, {
      text: tag,
      design: "warning",
      size: "sm"
    }), displayPrice && /*#__PURE__*/_react.default.createElement(_text.default.span, {
      "data-cy": "price",
      as: "title",
      size: 2,
      text: displayPrice
    }), displayPriceDescription && /*#__PURE__*/_react.default.createElement(_text.default.span, {
      "data-cy": "price-description",
      size: -1,
      text: displayPriceDescription
    }));
    const includedPriceContent = /*#__PURE__*/_react.default.createElement(_text.default.span, {
      "data-cy": "included-price",
      as: "title",
      size: 2,
      text: included
    });
    return /*#__PURE__*/_react.default.createElement(PriceContent, {
      ref: priceContentRef,
      "data-cy": "price-content",
      hasVideo: hasVideo,
      isHidden: checked && hasMultipleOptions && !isIncluded,
      priceContentHeight: priceContentHeight
    }, isIncluded ? includedPriceContent : priceBlockContent);
  }, [isIncluded, hasVideo, checked, hasMultipleOptions, tag, displayPrice, displayPriceDescription, priceContentHeight]);
  const toggleButton = /*#__PURE__*/_react.default.createElement(_toggleButton.default, (0, _extends2.default)({
    ref: attachmentRef,
    "data-cy": "attachment-toggle"
  }, !hasMultipleOptions && {
    'data-pc-enum': inputValue
  }, {
    value: inputValue,
    small: "true",
    role: "switch",
    className: customToggleStyles,
    active: displayDisable ? 'true' : checked,
    "aria-label": ariaLabel,
    "aria-checked": checked ? 'true' : 'false',
    onClick: handleToggleChange,
    disabled: displayDisable || isIncluded
  }));
  let startAlignedContent;
  let endAlignedContent;
  if (hasVideo && shouldShowPriceContent) {
    startAlignedContent = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, productContent, priceContent);
    endAlignedContent = videoContainer;
  } else if (hasVideo) {
    startAlignedContent = productContent;
    endAlignedContent = videoContainer;
  } else if (shouldShowPriceContent) {
    startAlignedContent = productContent;
    endAlignedContent = priceContent;
  } else {
    startAlignedContent = productContent;
    endAlignedContent = null;
  }
  return /*#__PURE__*/_react.default.createElement(AttachmentContainer, {
    id: `id-${id}`,
    "data-cy": "attachment-container",
    hasVideo: hasVideo
  }, /*#__PURE__*/_react.default.createElement(TrackingProxy, (0, _extends2.default)({
    id: `id-${id}-toggle`
  }, trackingProps)), /*#__PURE__*/_react.default.createElement(AttachmentContent, null, toggleButton, /*#__PURE__*/_react.default.createElement(ContentWrapper, {
    className: hasMultipleOptions && 'has-multiple-options'
  }, /*#__PURE__*/_react.default.createElement(_splitPanelItem.default, {
    startAlignedContent: startAlignedContent,
    endAlignedContent: endAlignedContent,
    allowWrap: true,
    hasVideo: hasVideo,
    endAlignedClassName: checked && !isIncluded ? 'hiding' : ''
  }), hasMultipleOptions && /*#__PURE__*/_react.default.createElement(PillSelectionWrapper, {
    isVisible: checked && !isIncluded,
    contentHeight: contentHeight,
    "data-visible": checked ? 'true' : 'false'
  }, /*#__PURE__*/_react.default.createElement("div", {
    ref: pillsRef
  }, /*#__PURE__*/_react.default.createElement(_pillSelection.default, {
    id: `pill-selection-${id}`,
    items: options,
    ariaLabel: ariaLabel,
    split: false,
    selected: selectedOption,
    setSelected: handleOptionSelect
  }))))), mobileVideoContainer);
}
Attachment.propTypes = {
  ariaLabel: _propTypes.default.string.isRequired,
  id: _propTypes.default.string,
  _name: _propTypes.default.string,
  productTagLabels: _propTypes.default.arrayOf(_propTypes.default.shape({
    text: _propTypes.default.string,
    design: _propTypes.default.string
  })),
  title: _propTypes.default.string.isRequired,
  secondaryTitle: _propTypes.default.string,
  description: _propTypes.default.string,
  list: _propTypes.default.arrayOf(_propTypes.default.shape({
    content: _propTypes.default.string.isRequired
  })),
  flyout: _propTypes.default.object,
  tag: _propTypes.default.string,
  price: _propTypes.default.string,
  priceDescription: _propTypes.default.string,
  onChange: _propTypes.default.func,
  inputName: _propTypes.default.string,
  inputValue: _propTypes.default.string,
  checked: _propTypes.default.bool,
  setChecked: _propTypes.default.func,
  image: _propTypes.default.object,
  video: _propTypes.default.object,
  displayDisable: _propTypes.default.bool,
  toggleProps: _propTypes.default.object,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string,
    _name: _propTypes.default.string,
    title: _propTypes.default.string,
    description: _propTypes.default.string,
    list: _propTypes.default.arrayOf(_propTypes.default.shape({
      content: _propTypes.default.string.isRequired
    })),
    tag: _propTypes.default.string,
    price: _propTypes.default.string,
    priceDescription: _propTypes.default.string,
    value: _propTypes.default.string
  })),
  selectedOption: _propTypes.default.number
};